var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDocs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 124 109",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Docs_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Docs_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122.748 17.983 60.58 8.35 46.575 98.73l62.168 9.633 14.005-90.381Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.21 8.292a.375.375 0 0 1 .428-.313l62.168 9.634a.375.375 0 0 1 .313.428l-14.005 90.381a.374.374 0 0 1-.428.313l-62.168-9.633a.375.375 0 0 1-.313-.428L60.21 8.292Zm.683.486-13.89 89.64 61.427 9.518 13.89-89.64-61.427-9.518Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m68.797 34.213 38.303 5.935-.46 2.965-38.302-5.935.459-2.965ZM67.09 45.231l38.302 5.936-.459 2.964-38.303-5.935.46-2.965ZM65.38 56.26l38.304 5.935-.46 2.965-38.303-5.936.46-2.964Z",
  fill: "#FFACE0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.341 83.283a2.5 2.5 0 0 1 2.854-2.088l27.373 4.242a2.5 2.5 0 1 1-.766 4.94l-27.373-4.24a2.5 2.5 0 0 1-2.088-2.854ZM93.711 88.61a2.5 2.5 0 0 1 2.853-2.088l2.61.404a2.5 2.5 0 0 1-.766 4.94l-2.61-.403a2.5 2.5 0 0 1-2.087-2.854Z",
  fill: "#FF59C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67 28.5 90.5 96l-34 4.5-9.5-2V96l29.5-4.5-9.5-63Z",
  fill: "#D80073"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Docs_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.693 10.424 39.94-5.953c12.303-1.834 23.772 6.668 25.604 18.962L76.4 91.61l-62.222 9.274L.693 10.424Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.322 10.48a.375.375 0 0 1 .316-.427L40.577 4.1c12.509-1.864 24.168 6.78 26.031 19.278L76.77 91.555a.375.375 0 0 1-.316.426l-62.222 9.275a.376.376 0 0 1-.426-.316L.322 10.48Zm.797.26 13.373 89.718 61.481-9.163-10.107-67.806c-1.802-12.09-13.08-20.45-25.179-18.647L1.12 10.74Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.683 4.474 3.322 22.284 22.234-3.315C64.406 11.15 52.97 2.663 40.683 4.473Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.382 4.25a.375.375 0 0 1 .246-.147C53.12 2.26 64.747 10.89 66.61 23.388a.375.375 0 0 1-.316.426L44.06 27.128a.375.375 0 0 1-.426-.315L40.312 4.529a.375.375 0 0 1 .07-.279Zm.728.543 3.21 21.538 21.49-3.203C63.856 11.363 52.926 3.252 41.11 4.793Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.572 69.916-4.431.66 2.438 16.36 4.431-.661-2.438-16.36ZM41.007 67.02l-4.43.66 2.438 16.359 4.43-.66-2.438-16.36ZM64.735 63.483l-4.431.66 2.438 16.36 4.431-.66-2.438-16.36ZM33.718 68.106l-9.16 1.365 2.44 16.359 9.158-1.365-2.438-16.36ZM57.317 64.588l-13.293 1.981 2.438 16.36 13.293-1.982-2.438-16.359Z",
  fill: "#FF59C1"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Docs_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h123.333v108.715H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Docs_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(8.808 -21.892 394.093)",
  d: "M0 0h64v92H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Docs_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-8.478 63.654 4.718)",
  d: "M0 0h64v93H0z"
})))));

export default SvgDocs;